import { isStorageAvailable, StorageWrapper } from "@utils/infrastructure/storage-util"

export interface MessageInChat {
    chatId: number
    message: string
}

const DATA_KEY_PREFIX = "chatMessages"
const VERSION = 1

export class ChatMessagesStorage {
    storage: StorageWrapper | undefined
    private static instance: ChatMessagesStorage
    static KEY = `${DATA_KEY_PREFIX}:${VERSION}`

    private constructor() {
        this.storage = isStorageAvailable ? new StorageWrapper(window.sessionStorage) : undefined
    }

    public static getInstance(): ChatMessagesStorage {
        if (!ChatMessagesStorage.instance) {
            ChatMessagesStorage.instance = new ChatMessagesStorage()
        }
        return ChatMessagesStorage.instance
    }

    getMessagesInChat(): MessageInChat[] {
        return this.storage?.getArray<MessageInChat>(ChatMessagesStorage.KEY) || []
    }

    updateMessageInChat(message: MessageInChat) {
        const current = this.getMessagesInChat()
        const index = current.findIndex((m) => m.chatId === message.chatId)

        if (index !== -1) {
            current[index].message = message.message
        } else {
            current.push(message)
        }

        this.storage?.storeArray(ChatMessagesStorage.KEY, current)
    }

    removeMessageInChat(chatId: number) {
        const updated = this.getMessagesInChat().filter((msg) => msg.chatId !== chatId)
        this.storage?.storeArray(ChatMessagesStorage.KEY, updated)
    }
}
